import { render, staticRenderFns } from "./support-expand.vue?vue&type=template&id=e1f29c2c&scoped=true&"
import script from "./support-expand.vue?vue&type=script&lang=js&"
export * from "./support-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f29c2c",
  null
  
)

export default component.exports